class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.attachEventListeners();
    window.SwymCallbacks.push(this.handleSwymLoad.bind(this));
  }

  attachEventListeners() {
    this.addEventListener('click', this.handleEvent.bind(this));
    this.addEventListener('submit', this.handleEvent.bind(this));
  }

  handleEvent(event) {
    event.preventDefault();
    this.updateCartQuantity();
  }

  updateCartQuantity() {
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    cartItems.updateQuantity(this.dataset.index, 0);
  }

  handleSwymLoad(swat) {
    if (typeof swat === undefined) {
      console.log('No swat provided to handleSwymLoad', 'background: #222; color: red');
      return
    }
    swat.evtLayer.addEventListener('sw:addedtowishlist', e => this.handleSwymEvent(e, swat));
  }

  async handleSwymEvent(event,swat) {
    if (!event) {
      console.log('No event provided to handleSwymEvent', 'background: #222; color: red');
      return
    }
    const { detail } = event || {};
    const { d } = detail || {};
    const { empi } = d || {};
    const queryString = `[data-cart-product-id="${empi}"]`;
    const productCard = document.querySelector(queryString);
    if (productCard) {
      const variantId = productCard.dataset.variantId || productCard.closest('[data-variant-id]').dataset.variantId;
      const cartItems = productCard.closest('cart-items') || productCard.closest('cart-drawer-items');
      await cartItems.removeItemSimple(variantId, 'swym');
      // Assuming swat.initializeActionButtons is available in the context
      swat.initializeActionButtons('cart-save-for-later');
    }
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.activeConditionManagers = [];

    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.autoAddInit();

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source !== 'condition-manager') {
        this.conditionManagerInit();
        if (event.source !== 'auto-add') this.autoAddInit();
        this.onCartUpdate();

        return;
      }
      if (event.source === 'cart-items') {
        return;
      }
      if (event.source === 'swym') {
        setTimeout(() => {
          this.onCartUpdate();
        }, 1000);
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  async updateCart(url, sectionId, callback) {
    try {
      const response = await fetch(`${url}?section_id=${sectionId}`);
      const responseText = await response.text();
      callback(responseText);
    } catch (e) {
      console.error(e);
    }
  }

  onCartUpdate() {
    this.updateCart(routes.cart_url, 'main-cart-items', (responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const sourceQty = html.querySelector('cart-items');
      this.innerHTML = sourceQty.innerHTML;
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-count-text',
        section: document.getElementById('cart-count-text').dataset.id,
        selector: '.cartHeading_cart-count-text',
      },
      {
        id: 'cart-rewards',
        section: document.getElementById('cart-rewards').dataset.id,
        selector: '.cart__rewards-inner-wrapper',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.cart__footer',
      },
    ];
  }

  disableCheckoutButtons() {
    const checkoutButtons = document.querySelectorAll('button[type="submit"][name="checkout"]');
    checkoutButtons.forEach(button => button.disabled = true);
  }

  async sendCartUpdateRequest(body) {
    return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then(response => response.text())
      .then(state => JSON.parse(state));
  }

  handleCartResponse(parsedState, line, name, quantity, variantId = null) {
    const validSelectors = this.getSectionsToRender().map(s => s.id?.replace(/([a-z0-9])([A-Z])/g, '$1-$2')?.toLowerCase());
    const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
    const items = document.querySelectorAll('.cart-item');

    if (parsedState.errors) {
      if (!quantityElement) return
      quantityElement.value = quantityElement.getAttribute('value');
      this.updateLiveRegions(line, parsedState.errors);
      return;
    }

    this.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

    this.getSectionsToRender().forEach((section) => {
      if (document.getElementById(section.id)) {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        const filteredObject = Object.keys(parsedState.sections).reduce((acc, key) => (validSelectors.includes(key) && (acc[key] = parsedState.sections[key]), acc), {});

        if (elementToReplace) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            filteredObject[section.section],
            section.selector
          );
        }
      }
    });

    const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
    let message = '';
    if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement?.value)) {
      if (typeof updatedValue === 'undefined') {
        if (name === 'swym') return
        message = window.cartStrings.error;
      } else {
        message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
      }
    }
    this.updateLiveRegions(line, message);

    const lineItem =
      document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
      cartDrawerWrapper
        ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
        : lineItem.querySelector(`[name="${name}"]`).focus();
    } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
    } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
    }

    
    const action = quantity === 0 ? 'delete' : 'update';

    const details = {
      variantId,
      line,
      quantity,
      name
    }

    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', action, details });
  }

  handleCartError(error, name) {
    console.log(error, 'background: #222; color: red');
    this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
    const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (name === 'swym') return;
    if (errors) {
      errors.textContent = window.cartStrings.error;
    }
  }

  updateQuantity(line, quantity, name) {
    this.disableCheckoutButtons();

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    this.sendCartUpdateRequest(body)
      .then(parsedState => this.handleCartResponse(parsedState, line, name, quantity))
      .catch(error => this.handleCartError(error, name))
      .finally(() => {
        this.disableLoading(line);
      });
  }

  async removeItemSimple(variantId, name = '') {
    if (!variantId) {
      console.log('No variant ID provided to removeItemSimple', 'background: #222; color: red');
      return
    }
    this.disableCheckoutButtons();
    const lineItem = document.querySelector(`[data-variant-id="${variantId}"]`);
    const line = lineItem.dataset.index;
    const quantity = 0;

    this.enableLoading(line);

    const body = JSON.stringify({
      id: variantId,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    })

    try {
        const parsedState = await this.sendCartUpdateRequest(body);
        this.handleCartResponse(parsedState, line, name, quantity, variantId);
    } catch (error) {
        this.handleCartError(error, name);
    } finally {
        this.disableLoading(line);
    }
}

  conditionManagerInit() {
    const giftProducts = document.querySelectorAll('[data-gift-product]');

    giftProducts.forEach(giftProduct => {
      // constants for each type of gift product
      const redeemProductId = giftProduct.dataset.redeemProduct;
      const autoGiftProductContent = giftProduct.dataset.autoGiftProduct;
      const multiAutoGiftProductContent = giftProduct.dataset.multiConditionAutoGiftProduct;
      const tieredAutoGiftProductContent = giftProduct.dataset.tieredAutoGiftProduct

      // variables for params that will be added to class
      let conditions;
      let options = {
        minimumNeededConditions: 1,
        checkoutButtonSelector: '.cart__checkout-button',
        indexProperty: 'index'
      };
      let selector;

      // set conditions and selector based on gift product type
      if (redeemProductId) {
        conditions = {
          cartTotalMinimum: 1
        };
        selector = `[data-redeem-product="${redeemProductId}"]`;
      } else if (autoGiftProductContent) {
        const autoGiftProductData = JSON.parse(autoGiftProductContent);
        conditions = {
          productInCart: autoGiftProductData.productInCart.map(id => id.toString()),
        };
        selector = `[data-variant-id="${autoGiftProductData.variantId}"]`;
      } else if (multiAutoGiftProductContent) {
        const multiAutoGiftProductContentData = JSON.parse(multiAutoGiftProductContent);
        conditions = {
          multiProductsInCart: multiAutoGiftProductContentData,
        };
        selector = `[data-variant-id="${multiAutoGiftProductContentData.variantId}"]`;
      } else if (tieredAutoGiftProductContent) {
        const tieredAutoGiftProductContentData = JSON.parse(tieredAutoGiftProductContent);
        conditions = {
          cartTotalMinimum: tieredAutoGiftProductContentData.price,
        };
        selector = `[data-variant-id="${tieredAutoGiftProductContentData.variantId}"]`;
      } else {
        console.warn('Unrecognized gift product type:', giftProduct);
        return;
      }

      // check if condition manager is already initialized for this selector
      if (this.activeConditionManagers.includes(selector) && !window.location.href.toLowerCase().includes('cart')) {
        console.warn('ConditionManager already initialized for selector:', selector);
        return;
      }

      // initialize condition manager
      const conditionManagerInstance = new ConditionManager(selector, conditions, options);

      // add selector to active condition managers list
      this.activeConditionManagers.push(selector);
    });
  }

  autoAddInit() {
    // Initialize instances for buy x get y sales.
    const autoAddListScriptElement = document.querySelector('[data-buy-x-get-y]');
    if (!autoAddListScriptElement) return;
    const autoAddListScriptContent = autoAddListScriptElement.innerText;
    const autoAddListObjectArray = JSON.parse(autoAddListScriptContent);
    autoAddListObjectArray.forEach(autoAddProductSettings => {
      const { autoAddQuantityMinimum, buyVariants, getVariants } = autoAddProductSettings.variant || {};
      const quantity = autoAddQuantityMinimum;
      const autoAddInstance = new AutoAdd("Classic", { buyVariants, getVariants, quantity });
    });

    // Initialize instances for buy a and b get c sales
    const autoAddMultiListScriptElement = document.querySelector('[data-buy-a-and-b-get-c]');
    if (autoAddMultiListScriptElement) {
      const autoAddMultiListScriptContent = autoAddMultiListScriptElement.innerText;
      const autoAddMultiListObjectArray = JSON.parse(autoAddMultiListScriptContent);
      autoAddMultiListObjectArray.forEach(autoAddProductSettings => {
        const { autoAddQuantityMinimum, buyVariantsList1, buyVariantsList2, getVariants } = autoAddProductSettings.multiCondition || {};
        const quantity = autoAddQuantityMinimum;

        const formattedBuyVariantsList1 = Array.isArray(buyVariantsList1) ? buyVariantsList1.join(',') : buyVariantsList1;
        const formattedBuyVariantsList2 = Array.isArray(buyVariantsList2) ? buyVariantsList2.join(',') : buyVariantsList2;
        const formattedGetVariants = Array.isArray(getVariants) ? getVariants.join(',') : getVariants;

        const buyVariants = [formattedBuyVariantsList1, formattedBuyVariantsList2];

        const autoAddInstance = new AutoAdd("Classic", { buyVariants, formattedGetVariants, quantity, listMode: 'dual' });
      });
    }

    // initialize instances for gwp tier sales
    const autoAddTierGwp = document.querySelector('[data-tier-gwp]');
    if (autoAddTierGwp) {
      const gWPTierContent = autoAddTierGwp.innerText;
      const gWPTierObjectArray = JSON.parse(gWPTierContent);
      gWPTierObjectArray.forEach(gWPTier => {
        const { priceRequired, gWPProduct, codeRequired } = gWPTier.gwpCondition || {};

        const autoAddInstance = new AutoAdd("GWP", { priceRequired, gWPProduct, codeRequired, listMode: 'tieredPrice' });
      });
    }

  }


  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedElement = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return parsedElement ? parsedElement.innerHTML : null; // Ensure that parsedElement is not null before accessing innerHTML
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
